<template>
	<div class="page">
		<div>{{res}}</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				res: {},
			};
		},
		created: function() {
			var self = this;
			this.$axios.get('/status.ok').then(function(res) {
				self.res = res.data
			});
			this.$axios.head('/status.ok').then(function(res) {});
		}
	};
</script>
<style>
</style>



// WEBPACK FOOTER //
// index.vue?7eaf260c